export default "__VITE_PUBLIC_ASSET__1fae6bdd__"